var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommercialTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7562,
    cy: 13.2397,
    r: 12.5,
    fill: "#57BC46"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1191_362",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.02844,
    y: 6.75366,
    width: 14,
    height: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1191_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77844 18.4204V16.787C6.77844 16.4565 6.86351 16.1527 7.03365 15.8756C7.20379 15.5985 7.42983 15.387 7.71178 15.2412C8.31455 14.9398 8.92705 14.7138 9.54928 14.5631C10.1715 14.4124 10.8034 14.337 11.4451 14.337C11.6396 14.337 11.834 14.3443 12.0284 14.3589C12.2229 14.3735 12.4173 14.3954 12.6118 14.4245C12.5729 14.9884 12.675 15.5207 12.918 16.0214C13.1611 16.5221 13.5159 16.9329 13.9826 17.2537V18.4204H6.77844ZM16.1118 20.1704L15.2368 19.2954V16.5829C14.809 16.4565 14.459 16.2159 14.1868 15.861C13.9146 15.5061 13.7784 15.0954 13.7784 14.6287C13.7784 14.0648 13.9777 13.5836 14.3764 13.185C14.775 12.7863 15.2562 12.587 15.8201 12.587C16.384 12.587 16.8652 12.7863 17.2639 13.185C17.6625 13.5836 17.8618 14.0648 17.8618 14.6287C17.8618 15.0662 17.7378 15.4551 17.4899 15.7954C17.242 16.1356 16.9284 16.3787 16.5493 16.5245L17.2784 17.2537L16.4034 18.1287L17.2784 19.0037L16.1118 20.1704ZM11.4451 13.7537C10.8034 13.7537 10.2541 13.5252 9.79719 13.0683C9.34025 12.6113 9.11178 12.062 9.11178 11.4204C9.11178 10.7787 9.34025 10.2294 9.79719 9.77245C10.2541 9.31551 10.8034 9.08704 11.4451 9.08704C12.0868 9.08704 12.6361 9.31551 13.093 9.77245C13.55 10.2294 13.7784 10.7787 13.7784 11.4204C13.7784 12.062 13.55 12.6113 13.093 13.0683C12.6361 13.5252 12.0868 13.7537 11.4451 13.7537ZM15.8201 14.9204C15.9854 14.9204 16.1239 14.8645 16.2357 14.7527C16.3475 14.6409 16.4034 14.5023 16.4034 14.337C16.4034 14.1718 16.3475 14.0332 16.2357 13.9214C16.1239 13.8096 15.9854 13.7537 15.8201 13.7537C15.6548 13.7537 15.5163 13.8096 15.4045 13.9214C15.2927 14.0332 15.2368 14.1718 15.2368 14.337C15.2368 14.5023 15.2927 14.6409 15.4045 14.7527C15.5163 14.8645 15.6548 14.9204 15.8201 14.9204Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialTenant);
export default __webpack_public_path__ + "static/media/commercial_tenant.7d80af2ffcf754d04c7ff9e593453b8d.svg";
export { ForwardRef as ReactComponent };